import React, { useEffect, useState } from 'react';
import './ChristmasLights.css';

const ChristmasLights = () => {
  const [lights, setLights] = useState([]);

  useEffect(() => {
    // Generate random lights
    const numberOfLights = 30;
    const generatedLights = [];
    
    for (let i = 0; i < numberOfLights; i++) {
      // Skip the logo area (approximately first 200px)
      const skipLogoArea = 200; // pixels to skip for logo
      const availableWidth = window.innerWidth - skipLogoArea;
      const position = skipLogoArea + (i * (availableWidth / numberOfLights)) + (Math.random() * 10);
      const positionPercent = (position / window.innerWidth) * 100;
      
      generatedLights.push({
        id: i,
        color: getRandomColor(),
        delay: Math.random() * 2,
        left: positionPercent
      });
    }
    
    setLights(generatedLights);
  }, []);

  const getRandomColor = () => {
    const colors = ['red', 'blue', 'green', 'yellow', 'orange', 'pink', 'purple', 'white'];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  return (
    <div className="christmas-lights-container">
      <div className="christmas-wire"></div>
      {lights.map((light) => (
        <div
          key={light.id}
          className={`christmas-light ${light.color}`}
          style={{
            left: `${light.left}%`,
            animationDelay: `${light.delay}s`
          }}
        >
          <div className="light-bulb"></div>
          <div className="light-glow"></div>
        </div>
      ))}
    </div>
  );
};

export default ChristmasLights;
